export default __webpack_public_path__ + "static/media/ventilator.068a9137.png";